import {api} from "../../../api/API";
import React, {useState} from "react";
import {useFilePicker} from "../shopdrawing/extras/FilePicker";
import {useSyncedRef} from "../../../misc/SyncedRef";
import {useAsyncAction} from "nate-react-api-helpers";
import {
    Button,
    DialogActions,
    DialogTitle,
} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {grey} from "@mui/material/colors";
import useWindowSize from "react-use/lib/useWindowSize";
import {sortStringInner, TID} from "../../../misc/scroller/Table";
import EditIcon from "@mui/icons-material/Edit";

export function FileCol<T extends TID>(name: string, editKey: keyof T, displayKey: keyof T) {
    return {
        name: name,
        width: 300,
        editable: {
            type: "custom",
            paste: (row: T, value: string) => {
                if(value === "null" || value === "") {
                    // @ts-ignore
                    row[editKey] = null as any;
                    // @ts-ignore
                    row[displayKey] = null as any;
                } else {
                    // @ts-ignore
                    row[editKey] = parseInt(value);
                }
            },
            copy: (row: T) =>{
                return (row[editKey]?.toString() || "null") as string
            },
            render: (props) => <FileChanger {...props} editKey={editKey} displayKey={displayKey} />,
        },
        filter: (row: T, search: string) => {
            return (row[displayKey] as string)?.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1;
        },
        sort: (a: T, b: T) => sortStringInner(a[displayKey] as string, b[displayKey] as string),
        render: (input: T) => {

            const value = input[editKey] as number;
            if(!value) return "(none)";

            const display = input[displayKey] as string;

            return (
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 10,
                }}>
                    <a href={api.files.downloadLink(value, "attachment")}>{display}</a>
                    <EditIcon fontSize="inherit" color="inherit" />
                </div>
            );
        },
    }
}

export function FileChanger<T>(props: {
    anchor: any;
    row: T;
    editKey: keyof T;
    displayKey: keyof T;
    width: number;
    initialValue: string;
    onCancel(): void;
    onDone(value: T): Promise<any>;
}) {
    const filePicker = useFilePicker({
        accept: ["application/pdf", "image/*"],
    });

    const initialId = props.row[props.editKey];
    const [selected, setSelected] = useState<{id: number, name: string} | null>(initialId ? {
        id: initialId as number,
        name: (props.row[props.displayKey] || "") as string,
    } : null);

    const action = useAsyncAction(async (file) => {
        const fileObj = await api.files.upload({
            file: file,
        });

        setSelected(fileObj);
    }, [filePicker]);

    const onDoneRef = useSyncedRef(props.onDone);
    const update = useAsyncAction(async (input) => {
        await onDoneRef.current(input);
    }, [props.row, selected]);

    const size = useWindowSize();

    const submit = () => {
        update.callback(Object.assign({}, props.row, {
            [props.editKey]: selected?.id || null,
            [props.displayKey]: selected?.name ||  null,
        }));
    };

    return (
        <>
            <Dialog2 open onClose={e => props.onDone(props.row)} onEnterPress={submit} fullWidth maxWidth="lg">
                <DialogTitle>Edit File</DialogTitle>
                <div style={{
                    width: "100%", height: size.height * 0.75, borderTop: "1px solid " + grey["300"],
                    display: "flex", flexDirection: "column"
                }}>

                    {selected ? <iframe
                        src={api.files.downloadLink(selected.id, "inline")}
                        style={{
                            flex: 1,
                        }}
                    ></iframe> : <div style={{
                        backgroundColor: grey["100"],
                        flex: 1,
                        display: "flex", alignItems: "center", justifyContent: "center"
                    }}>
                        <div>
                            Please upload a file below
                        </div>
                    </div>}
                </div>
                <DialogActions>
                    {action.LoadingElement}
                    <Button variant="outlined" onClick={async () => {
                        const files = await filePicker();
                        action.callback(files[0])
                    }}>
                        Upload File
                    </Button>
                    {selected && <Button variant="outlined" color="error" onClick={async () => {
                        setSelected(null);
                    }}>
                        Remove File
                    </Button>}
                    <div style={{flex: 1}} />
                    {update.LoadingElement}
                    <Button onClick={e => props.onDone(props.row)}>Cancel</Button>
                    <Button variant="contained" color="primary" onClick={submit}>Update</Button>
                </DialogActions>
            </Dialog2>
        </>
    )
}